import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)
Vue.use(Cookies)

export  default new Vuex.Store({
    state:{
        collapsed: false,
        sidebar_current: ['1'],
        sidebar_openKeys: ['1'],
        //collapsed:true,//左侧sidebar状态，false=展开，true=关闭
    },
    mutations:{
        GoMenu (state,value){
            state.collapsed = value
        },
        sidebar_current (state,value){
            state.sidebar_current = value
        },
        sidebar_openKeys (state,value){
            state.sidebar_openKeys = value
        },
    },
    setter:{

    },
    actions:{

    }
})